import { get } from "@/utils/get";

import { Autocomplete, Box, TextField } from "@mui/material";
import PropTypes from "prop-types";

function InputAutocomplete({
  fullWidth = true,
  getOptionLabel,
  renderOptionLabel,
  selects,
  selectValue = "value",
  value,
  error,
  onChange,
  id,
  name,
  label,
  helperText,
  hasEmpty,
  required,
  ...props
}) {
  const options = Array.isArray(selects) ? selects : [];

  const optionValue = (option) => (typeof option === "object" && option !== null ? option[selectValue] : option);
  const optionLabel = (option) =>
    typeof getOptionLabel === "function" ? getOptionLabel(option) : String(option ?? "");

  return (
    <Autocomplete
      {...props}
      id={id}
      fullWidth={fullWidth}
      options={options}
      disableClearable={hasEmpty === undefined || hasEmpty === false}
      value={options.find((option) => optionValue(option) === value) ?? null}
      onChange={(e, newValue) => onChange(id, newValue !== null ? optionValue(newValue) : hasEmpty)}
      getOptionLabel={optionLabel}
      isOptionEqualToValue={(option, val) => optionValue(option) === optionValue(val)}
      renderOption={
        typeof renderOptionLabel === "function"
          ? ({ key, ...optionProps }, option) => (
              <Box component="li" key={key ?? optionValue(option)} {...optionProps}>
                {renderOptionLabel(option)}
              </Box>
            )
          : undefined
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          placeholder={name ?? label}
          error={!!get(name ?? id, error)}
          helperText={get(name ?? id, error)?.[0] || helperText}
        />
      )}
    />
  );
}

InputAutocomplete.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.object,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selects: PropTypes.array,
  getOptionLabel: PropTypes.func,
  renderOptionLabel: PropTypes.func,
  selectValue: PropTypes.string,
  onChange: PropTypes.func,
  hasEmpty: PropTypes.any,
};

export default InputAutocomplete;
